import { toast } from 'react-toastify';

// https://www.npmjs.com/package/react-toastify
const notificationService = {
	success: (msg) => {
		instance.message(msg, { type: 'success' });
	},

	error: (message) => {
		instance.message(message, { type: 'error' });
	},

	info: (message) => {
		instance.message(message, { type: 'info' });
	},

	message: (message, opts = null) => {
		const { type } = opts;
		let content = message;
		if (typeof message === 'string')
			content = <p className={`text-white`} dangerouslySetInnerHTML={{ __html: message }} />;

		console.log('stuff', content, opts);
		toast(content, opts);
	}
}

const instance = Object.freeze(notificationService);

export { instance as NotificationService };